export const SUBTITLE = {
  subtitle1: "EAO Spring Break",
  subtitle2:
    "3 days of hands-on training in a golf resort in Cascais, Portugal.",
  subtitle3: "Surgical and prosthetic concepts: How to do it the EAO way?",
};
